import React from "react";
import PropTypes from 'prop-types';
import SelectDataTable from '../form/SelectDataTable';
import WorkScheduleColumn from "../../component/dataTable/columns/WorkScheduleColumn.json";
import Service from "../../../shared/service/Service";

export default class WorkScheduleGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            validate: this.props.validate,
            dataTable: this.props.dataTable,
            label: this.props.label,
            disabled: this.props.disabled
        };
        this.service = new Service('workSchedule');
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            validate: nextProps.validate,
            value: nextProps.value,
            dataTable: nextProps.dataTable,
            label: nextProps.label,
            disabled: nextProps.disabled
        });
    }

    render() {
        let validate = this.state.validate;
        if (!validate) {
            validate = {
                required: {
                    value: true,
                    errorMessage: "Bu alanın doldurulması zorunludur."
                }
            };
        }

        let dataTable = this.state.dataTable;
        if (!dataTable) {
            dataTable = {
                dataURL : "workSchedule/findAll",
                fields: WorkScheduleColumn.fields
            };
        }

        let label = this.state.label;
        if (!label) {
            label = "Çalışma Takvimi"
        }
        return (
            <SelectDataTable
                value={this.state.value}
                validate={validate}
                dataTable={dataTable}
                disabled={this.state.disabled}
                name="requestedBy"
                translateKey="defaultHsmUserGroup"
                label={label}
                dialogHeader="Çalışma Takvimi Listesi"
                onDataSelect={this.props.onDataSelect}
                autoRefrestData={this.props.autoRefrestData ? this.props.autoRefrestData : false}
            />
        );
    }
}
WorkScheduleGroup.propTypes = {
    value: PropTypes.string,
    validate: PropTypes.object,
    dataTable: PropTypes.object
}